import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { apiClient, formatApiError } from "@/lib/auth";
import { inputCls } from "./FormRenderer";

const lbl = "block font-mono text-[0.6rem] tracking-[0.16em] uppercase text-slate-400 mb-1";

// Configure which documents a card's Document Library shows: a folder, or hand-picked files.
export default function DocLibraryConfig({ docs, onChange }) {
  const d = { mode: "folder", folder: "", ids: [], ...(docs || {}) };
  const [folders, setFolders] = useState([]);
  const [all, setAll] = useState([]);
  const [newName, setNewName] = useState("");
  const [q, setQ] = useState("");
  const loadFolders = () => apiClient.get("/documents/folders").then(({ data }) => setFolders(data.folders || [])).catch(() => {});
  useEffect(() => { loadFolders(); }, []);
  useEffect(() => { if (d.mode === "picked") apiClient.get("/documents?limit=500").then(({ data }) => setAll(data.items || data.documents || [])).catch(() => {}); }, [d.mode]);

  const createFolder = async () => {
    if (!newName.trim()) return;
    try { const { data } = await apiClient.post("/documents/folders", { name: newName }); setNewName(""); await loadFolders(); onChange({ ...d, folder: data.name }); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const toggle = (id) => onChange({ ...d, ids: d.ids.includes(id) ? d.ids.filter((x) => x !== id) : [...d.ids, id] });
  const shown = all.filter((x) => !q || x.original_filename.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="doc-library-config" className="mt-3 rounded-md border border-brand-cyan/30 bg-brand-cyan/[0.04] p-3 space-y-3">
      <div className="font-mono text-[0.6rem] tracking-[0.18em] uppercase text-brand-cyan">Document Library shows</div>
      <div className="flex gap-4 text-sm text-slate-300">
        {[["folder", "A folder"], ["picked", "Hand-picked files"]].map(([v, l]) => (
          <label key={v} className="inline-flex items-center gap-1.5"><input type="radio" checked={d.mode === v} onChange={() => onChange({ ...d, mode: v })} data-testid={`doc-library-mode-${v}`} /> {l}</label>
        ))}
      </div>
      {d.mode === "folder" ? (
        <>
          <label className="block"><span className={lbl}>Folder</span>
            <select value={d.folder} onChange={(e) => onChange({ ...d, folder: e.target.value })} data-testid="doc-library-folder" className={inputCls}>
              <option value="">All documents (uploads go unfiled)</option>
              {folders.map((f) => <option key={f.name} value={f.name}>{`${f.name} (${f.count})`}</option>)}
            </select>
          </label>
          <div className="flex gap-2">
            <input value={newName} onChange={(e) => setNewName(e.target.value)} placeholder="New folder name" data-testid="doc-library-new-folder" className={`${inputCls} flex-1`} />
            <button type="button" onClick={createFolder} data-testid="doc-library-create-folder" className="px-3 rounded-md border border-brand-cyan/50 text-brand-cyan font-mono text-[0.6rem] tracking-[0.14em] uppercase hover:bg-brand-cyan/10">Create</button>
          </div>
        </>
      ) : (
        <>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search the vault…" data-testid="doc-library-pick-search" className={inputCls} />
          <ul className="max-h-48 overflow-y-auto space-y-1">
            {shown.map((x) => (
              <li key={x.id}>
                <label className="flex items-center gap-2 text-sm text-slate-300 cursor-pointer">
                  <input type="checkbox" checked={d.ids.includes(x.id)} onChange={() => toggle(x.id)} data-testid={`doc-library-pick-${x.id}`} className="accent-cyan-400" />
                  <span className="truncate">{x.original_filename}</span>
                </label>
              </li>
            ))}
          </ul>
          <div className="text-xs text-slate-500">{d.ids.length} selected</div>
        </>
      )}
    </div>
  );
}
